<template>
  <card class="card" title="Upload Accounts">
    <div>
      <form @submit.prevent>
        <div class="row">
          <div class="col-md-6">
            <label
              >Add File<span class="required" v-if="!file">*</span
              ><span class="required-field" v-if="!file"
                >[required field]</span
              ></label
            >
            <div>
              <input
                type="file"
                class="form-control"
                accept=".csv"
                :file="this.file"
                @change="fileChange"
              />
            </div>
            <span class="required-text" v-if="!file">Please add a file.</span>
          </div>
        </div>

        <div class="text-center">
          <p-button type="info" round @click.native.prevent="submit">
            <div
              class="spinner-grow"
              role="status"
              v-if="loading.show === true"
            ></div>
            Upload Account Number
          </p-button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "../store/axios";
import Multiselect from "vue-multiselect";
import router from "@/router";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      file: "",
    };
  },
  computed: {
    ...mapState(["auth", "loading", "utils"]),
  },
  methods: {
    ...mapActions(["setNotification"]),
    submit() {
      const formData = new FormData();
      formData.append("csvFile", this.file);
      this.loading.show = true;
      axios
        .post(`${process.env.VUE_APP_API_URL}/regularize-account`, formData)
        .then((response) => {
          this.setNotification({
            type: "success",
            message: response.data.message || "Submitted Successfully",
          });
          router.replace("/dashboard");
        })
        .catch((error) => {
          this.setNotification({
            type: "danger",
            message: error.response.data.message || "An error occurred",
          });
          console.error(error);
        })
        .finally(() => {
          this.loading.show = false;
        });
    },
    fileChange(e) {
      const file = e.target.files[0];
      this.file = file;
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.required {
  color: red;
  margin-left: 2px;
}

.required-field {
  font-size: 0.8rem;
  color: #888;
  margin-left: 5px;
}
</style>
